import findBySlug from "./find-by-slug";

const findDay = (seasonContentForSchoolLevel, route) =>
  findBySlug(seasonContentForSchoolLevel?.days, route.params.daySlug);

export default function resolveRoutedDay(
  route,
  parentSeasonContentForSchoolLevel,
  { getters },
) {
  if (!getters.containerLoaded) {
    return null;
  }

  // If no day slug route parameter is provided, we fall back
  // to the auto day, which might be the current day
  // (if the current season(-content for the active school level)
  // is selected and the current date is represented as one of
  // this season's days); might be the first day of the
  // active 'season content for school level'; might
  // be null in all other cases.
  if (!route.params?.daySlug) {
    return null;
  }

  // If a season slug route parameter is provided, we use this
  // parameter to match one of the selected volume's seasons.
  // If none matches because the season slug route param
  // is invalid, then an automatic fallback is chosen.
  return findDay(parentSeasonContentForSchoolLevel, route);
}
